<template>
  <div class="card-visit-todolist">
    <h3 class="pb-2 text-red">To Do List</h3>
    <div v-if="todo != ''">
      <div v-for="(item, index) in todo" :key="index" class="todolist">
        <img
          :src="[item.status ? 'img/icons_v2/icon-checked.png' : 'img/icons_v2/icon-check2.png']"
          width="30px"
          height="30px"
        />
        <label>{{ item.detail }}</label>
      </div>
    </div>
    <div v-else class="todolist">
      <label class="pl-0 ml-0">ไม่มีรายการ To Do List</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['todo']
}
</script>

<style lang="scss" scoped src="@/assets/scss/visit/visit-todolist.scss"></style>
